import { Modal } from '@mui/material';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import React, { useEffect, useState } from 'react';
import { Signup } from '../components';

const Inspector = React.lazy(() => import('./Inspector'));

const Block = ({ image, loginPage, howToLink, redirectTo }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => {
        setOpenModal(false);
        if (redirectToHomeOnClose) {
            window.location.replace('/');
        }
    };

    const [redirectToHomeOnClose, setRedirectToHomeOnClose] = useState(false);

    // Listen to the event "openPopinSignup"
    useEffect(() => {
        const callback = (e) => {
            setOpenModal(e.detail.openModal);
            if (e.detail.redirectToHome) {
                setRedirectToHomeOnClose(true);
            }
        };
        document.addEventListener('openPopinSignup', callback);
        return () => {
            document.removeEventListener('openPopinSignup', callback);
        };
    }, []);

    // Open pop-in after being redirected
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (window.location.pathname === '/' && urlParams.has('login')) {
            // Remove the param "login" from url
            window.history.pushState({}, document.title, '/');

            // Fire the event "openPopinSignup" after 500ms
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('openPopinSignup', { detail: { openModal: true } }));
            }, 500);
        }
    }, []);

    return (
        <BlockWrapper.Div>
            {isEditing ? (
                <Signup image={image} loginPage={loginPage} questionLink={howToLink} redirectTo={redirectTo} />
            ) : (
                <Modal open={openModal} sx={{ display: 'flex', overflow: 'auto' }} onClose={handleClose}>
                    <Signup
                        image={image}
                        loginPage={loginPage}
                        questionLink={howToLink}
                        redirectTo={redirectTo}
                        handleClose={handleClose}
                    />
                </Modal>
            )}
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.image,
    },
    setup: {
        title: 'Pop-in d’inscription',
    },
});
